// import React, { useState } from "react";
import { useRecoilState } from "recoil";
import { navbarState } from "../atom/navbarState";
import { useNavigate } from "react-router-dom";

import {
  Group,
  Box,
  Collapse,
  ThemeIcon,
  Text,
  UnstyledButton,
  createStyles,
  rem,
} from "@mantine/core";

import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";

export const LinksGroup = ({ icon: Icon, label, link, links }) => {
  const navigate = useNavigate();
  const { classes, theme } = useStyles();

  const hasLinks = Array.isArray(links);

  const [opened, setOpened] = useRecoilState(navbarState);

  const handleClick = () => {
    setOpened((prevOpened) => ({
      ...prevOpened,
      [label]: !prevOpened[label], // 각 LinksGroup의 label을 key로 사용하여 opened 상태 업데이트
    }));
    if (link) navigate(link);
  };

  const ChevronIcon = theme.dir === "ltr" ? IconChevronRight : IconChevronLeft;

  const items = (hasLinks ? links : []).filter(Boolean).map((link) => (
    <Text
      component="div"
      className={classes.link}
      key={link.label}
      onClick={() => navigate(link.link)}
    >
      {link.label}
    </Text>
  ));

  return (
    <>
      <UnstyledButton onClick={handleClick} className={classes.control}>
        <Group position="apart" spacing={0}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <ThemeIcon variant="light" size={30}>
              <Icon />
            </ThemeIcon>
            <Box ml="md">{label}</Box>
          </Box>
          {hasLinks && (
            <ChevronIcon
              className={classes.chevron}
              size="1rem"
              stroke={1.5}
              style={{
                transform: opened
                  ? `rotate(${theme.dir === "rtl" ? -90 : 90}deg)`
                  : "none",
              }}
            />
          )}
        </Group>
      </UnstyledButton>
      {hasLinks ? <Collapse in={opened[label]}>{items}</Collapse> : null}
    </>
  );
};

const useStyles = createStyles((theme) => ({
  control: {
    fontWeight: 500,
    display: "block",
    width: "100%",
    padding: `${theme.spacing.xs} ${theme.spacing.md}`,
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    fontSize: theme.fontSizes.sm,

    "&:hover": {
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.dark[7]
          : theme.colors.gray[0],
      color: theme.colorScheme === "dark" ? theme.white : theme.black,
    },
  },

  link: {
    fontWeight: 500,
    display: "block",
    textDecoration: "none",
    padding: `${theme.spacing.xs} ${theme.spacing.md}`,
    paddingLeft: rem(31),
    marginLeft: rem(30),
    fontSize: theme.fontSizes.xs,
    borderLeft: `${rem(1)} solid ${
      theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]
    }`,

    "&:hover": {
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.dark[7]
          : theme.colors.gray[0],
      color: theme.colorScheme === "dark" ? theme.white : theme.black,
      cursor: "pointer",
    },
  },

  chevron: {
    transition: "transform 200ms ease",
  },
}));
